import { PreguntaExportador } from "../PreguntaExportador";
import { PreguntasTipoEnum } from "@shared/enums";

export class PreguntaNumericTextExportador extends PreguntaExportador {
    public puedeProcesar(tipoPregunta: PreguntasTipoEnum): boolean {
        return tipoPregunta === PreguntasTipoEnum.NUMERIC_TEXT;
    }
}
